import {FormControl, FormField} from 'platform/components';
import {VStack, Show} from 'platform/foundation';

import {UseFormReturn, useWatch} from 'react-hook-form';

import {isNilOrEmpty} from 'ramda-adjunct';

import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';

import {getSafely} from 'shared/web';

import {BEFORE_OPENING, BEFORE_CLOSING} from '../../../conditions/mandatoryConditions';
import {VEHICLE_MANDATORY_FIELDS} from '../../../constants/vehicleMandatoryFields';
import {FormType, MandatoryFieldType} from '../../../types/ServiceOrderVariant';

interface VehicleMandatoryFieldsProps {
  control: FormControl<FormType>;
  formApi: UseFormReturn<FormType>;
}

export function VehicleMandatoryFields(props: VehicleMandatoryFieldsProps) {
  const mandatoryFields = useWatch({
    control: props.control,
    name: 'mandatoryFields',
  });

  const handleCheckboxChange = (fieldType: MandatoryFieldType) => (value: boolean) => {
    if (!value) {
      return;
    }

    const conditionFieldValue = props.formApi.getValues(`mandatoryFieldConditions.${fieldType}`);

    if (isNilOrEmpty(conditionFieldValue)) {
      props.formApi.setValue(`mandatoryFieldConditions.${fieldType}`, [BEFORE_OPENING]);
    }
  };

  return (
    <>
      {VEHICLE_MANDATORY_FIELDS.map((field) => (
        <VStack key={field.id} spacing={4}>
          <FormField
            control={props.control}
            label={field.label}
            name={`mandatoryFields.${field.id}`}
            type="checkbox"
            onChange={handleCheckboxChange(field.id)}
            data-testid={testIds.settings.serviceOrderVariantsDetail(`mandatory-${field.id}`)}
          />
          <Show when={getSafely(mandatoryFields, field.id)}>
            <FormField
              control={props.control}
              type="chips"
              options={[
                {label: i18n.t('entity.order.labels.beforeOpening'), value: BEFORE_OPENING},
                {label: i18n.t('entity.order.labels.beforeClosing'), value: BEFORE_CLOSING},
              ]}
              name={`mandatoryFieldConditions.${field.id}`}
              data-testid={testIds.settings.serviceOrderVariantsDetail(
                `mandatoryCondition-${field.id}`
              )}
            />
          </Show>
        </VStack>
      ))}
    </>
  );
}
